const { isEmpty } = require('lodash');

const fields = () => {
  return {
    amount: {
      label: '金額',
      type: 'integer',
      validations: {
        required: (_) => _ != null,
      },
    },
    description: {
      label: '説明',
      type: 'string',
      validations: {
        required: (_) => _ != null,
      },
    },
  };
};

module.exports = {
  fields,
};
